<template>
    <div class="apply-area">
        <apply-header title="その他申請"></apply-header>
        <div style="margin-left: 30px; fontSize:72px; fontWeight: 600;">工事中</div>
    </div>
</template>

<script>
    import applyHeader from '../component/applyHeader.vue';

    export default {
        name: "OtherApplications",
        components: {
            applyHeader
        },
        created() {

        },

        data() {
            return {
            }
        },

        computed: {

        },

        methods: {

        }

    }
</script>

<style lang="scss" scope>

</style>


// WEBPACK FOOTER //
// src/view/applyType/OtherApplications.vue